module.exports = __webpack_public_path__ + "img/9788901105956.e4063c98.jpg";